<script lang="ts" setup>
const props = defineProps<{
  title?: string
  list: string[]
}>()

const length = computed(() => props.list.length || 0)

function resolve(url: string) {
  return resizeImg(url, 600)
}
</script>

<template>
  <div
    class="m-gallery"
    :class="{
      single: length === 1,
      trible: length === 2 || length === 3,
      forth: length === 4,
      sixth: length === 5 || length === 6,
      ninth: length >= 7
    }"
  >
    <div v-for="img in list.slice(0, 9)" :key="img" class="m-gallery-item">
      <img :src="resolve(img)" :alt="title || '插画'" class="preview" />
    </div>
    <div v-if="list.length > 9" class="hidden">
      <img
        v-for="img in list.slice(9)"
        :key="img"
        :src="resolve(img)"
        :alt="title || '插画'"
        class="preview"
      />
    </div>
    <div v-if="length > 9" class="more">+{{ length - 9 }}</div>
  </div>
</template>

<style lang="scss" scoped>
.m-gallery {
  $padding: 2px;
  $borderRadius: 6px;
  $maxWidth: 375px;
  $width: min(100%, $maxWidth);

  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: $width;
  height: 0;
  padding-bottom: $width;
  &-item {
    height: 0;
    overflow: hidden;
    position: relative;
    img {
      display: block;
      position: absolute;
      object-fit: cover;
      top: $padding;
      left: $padding;
      right: $padding;
      bottom: $padding;
      width: calc($width - $padding * 2);
      height: calc($width - $padding * 2);
      border: 1px solid var(--color-border);
      border-radius: $borderRadius;
    }
  }
  .more {
    pointer-events: none;
    position: absolute;
    width: calc($width / 3);
    height: calc($width / 3);
    border-radius: $borderRadius;
    bottom: 0;
    right: 0;
    padding: $padding;
    background-clip: content-box;
    background-color: rgba($color: #000, $alpha: 0.5);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  &.single {
    height: auto;
    padding-bottom: 0;
    .m-gallery-item {
      width: $width;
      height: $width;
      padding-bottom: 0;
      img {
        position: static;
        max-height: 400px;
      }
    }
  }
  &.trible {
    padding-bottom: calc(min($width, $maxWidth) / 3);
    .m-gallery-item {
      width: calc($width / 3);
      padding-bottom: calc($width / 3);
    }
  }
  &.forth {
    .m-gallery-item {
      width: calc($width / 2);
      padding-bottom: calc($width / 2);
    }
  }
  &.sixth {
    padding-bottom: calc($width / 3 * 2);
    .m-gallery-item {
      width: calc($width / 3);
      padding-bottom: calc($width / 3);
    }
  }
  &.ninth {
    .m-gallery-item {
      width: calc($width / 3);
      padding-bottom: calc($width / 3);
    }
  }
}
</style>
